"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuDesktop = _interopRequireDefault(require("../MenuDesktop"));

var _MenuMobile = _interopRequireDefault(require("../MenuMobile"));

var _navPropType = _interopRequireDefault(require("../../../constants/navPropType"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _Menu = require("./Menu.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Menu component.
 * Container for desktop and mobile renderings.
 * Children should be of type 'MenuItem'.
 */
var Menu = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Menu, _React$PureComponent);

  var _super = _createSuper(Menu);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["className"]);

      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react.default.createElement(_Menu.StyledMenu, {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-menu-grid-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_MenuDesktop.default, _extends({
        className: "desktop",
        dataTestId: "menu-desktop"
      }, props)), /*#__PURE__*/_react.default.createElement(_MenuMobile.default, _extends({
        className: "mobile",
        dataTestId: "menu-mobile",
        isOpen: isOpen
      }, props))));
    }
  }]);

  return Menu;
}(_react.default.PureComponent);

_defineProperty(Menu, "propTypes", {
  /** child elements will be displayed in the center of the header area */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** click handler for desktop contact us link */
  contactClick: _propTypes.default.func,

  /** logged in state flag for internal/external view */
  loggedIn: _propTypes.default.bool,

  /** log in event handler */
  logInHandler: _propTypes.default.func,

  /** alternate logo uri */
  logo: _propTypes.default.string,

  /** onClick function for the logo */
  logoOnClick: _propTypes.default.func,

  /** log out event handler */
  logOutHandler: _propTypes.default.func,

  /** navConfig to be displayed in side nav.
   * If you provide a subNav prop, it will trump the onclick if it is also provided.
   *  */
  navConfig: _navPropType.default.navConfig,

  /** phone number to use in the mobile header */
  phoneNo: _propTypes.default.string,

  /** flag only to be used by styleguide to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
});

_defineProperty(Menu, "defaultProps", {
  children: undefined,
  className: '',
  contactClick: function contactClick() {},
  loggedIn: false,
  logInHandler: function logInHandler() {},
  logo: null,
  logoOnClick: function logoOnClick() {},
  logOutHandler: function logOutHandler() {},
  navConfig: undefined,
  phoneNo: '',
  _inStyleGuide: false
});

var _default = Menu;
exports.default = _default;